<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import QrcdAddMain from '@/views/StockManagement/QrcdManage/TabChild/QrcdAddMain';
export default {
  name: 'QrcdAdd',
  components: {
    childTab1: QrcdAddMain
  },
  data() {
    return {
      activeName: 'first'
    };
  }
};
</script>

<style scoped></style>
